export var notInitialized = () => {
  throw new Error('uSES not initialized!');
};